const runConsentEvent = require('./runConsentEvent');

let initialized = false;

const runAfterConsent = function(force) {
  if (!initialized || force) {
    window.WP.push(function () {
      window.WP.gdpr.runAfterConsent(function () {
        runConsentEvent.runConsentEvent();
      });
    });

    initialized = true;
  }
};

module.exports = { runAfterConsent };
